<template>
  <a-card :bordered="false">
    <div class="table-operator" style="margin-bottom:12px;">
      <h-select v-model="scope" placeholder="查看范围" style="width:170px;" :options="scopeOptions" @change="loadList"/>
      <a-button type="primary" icon="plus" style="margin-left:8px;" @click="openEdit({})">新增</a-button>
      <a-button icon="copy" style="margin-left:8px;" @click="copyFromSystem">从系统预置复制（如空）</a-button>
      <a-button icon="rollback" style="margin-left:8px;" @click="restorePreset">恢复系统预置</a-button>
      <a-button icon="sync" style="margin-left:8px;" @click="loadList">刷新</a-button>
      <p class="muted small" style="margin-top:6px;">
        说明：系统预置行(tenant_id=0)仅超级管理员可编辑；租户管理员编辑的是「租户副本」。
        对副本执行<b>删除=软删</b>，等效于<b>禁用该系统预置项</b>，可点击「恢复系统预置」一键还原（Z模式）。
      </p>
    </div>

    <a-table bordered size="middle" rowKey="id" :columns="cols" :dataSource="rows" :pagination="false" :loading="loading">
      <template slot="src_slot" slot-scope="t">
        <a-tag :color="t==='system'?'purple':'green'">{{ t==='system'?'系统预置':'租户自定义' }}</a-tag>
      </template>
      <template slot="cat_slot" slot-scope="t">
        <a-tag>{{ t || '—' }}</a-tag>
      </template>
      <template slot="en_slot" slot-scope="t, r">
        <span v-if="r.deleted" class="text-red">[已删除]</span>
        <template v-else>
          <a-tag :color="t==='1'||t===true?'green':'default'">{{ t==='1'||t===true?'启用':'停用' }}</a-tag>
        </template>
      </template>
      <template slot="action" slot-scope="t, r">
        <template v-if="r._editable">
          <a @click="openEdit(r)">编辑</a>
          <a-divider type="vertical"/>
          <a style="color:red;" @click="del(r)">删除</a>
        </template>
        <span class="muted" v-else>系统行（无权限）</span>
      </template>
    </a-table>

    <!-- 编辑 Modal -->
    <a-modal :title="form.id ? '编辑主数据注册' : '新增主数据注册（辅助核算类别来源）'" :visible="modal" :confirmLoading="saving" :maskClosable="false" :width="680" @ok="save" @cancel="modal=false">
      <a-form layout="vertical">
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item label="辅助核算类别" required>
              <a-input v-model="form.category_name" placeholder="例：资金账户/客户/供应商/部门/职员/仓库/存货"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="类别类型" required>
              <a-select v-model="form.category_type">
                <a-select-option value="system">系统型（引用主数据表）</a-select-option>
                <a-select-option value="custom">自定义型（独立明细表）</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="form.category_type==='system'">
            <a-alert type="info" showIcon message="系统型：辅助明细直接引用业务主数据表，保证数据单一来源；系统预置的9项不建议修改。"/>
          </a-col>
          <a-col :span="12" v-if="form.category_type==='system'">
            <a-form-item label="主数据表名(source_table)">
              <a-select v-model="form.source_table" showSearch>
                <a-select-option v-for="t in sourceTables" :key="t.v" :value="t.v">{{ t.v }} · {{ t.label }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="form.category_type==='system'">
            <a-form-item label="名称列(source_name_column)">
              <a-input v-model="form.source_name_column" placeholder="例：name / supplier / org_abr"/>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="form.category_type==='system'">
            <a-form-item label="编码列(source_code_column)">
              <a-input v-model="form.source_code_column" placeholder="例：code / model / org_no / 可空"/>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="form.category_type==='system'">
            <a-form-item label="过滤启用状态值(enabled_filter_value)">
              <a-input v-model="form.enabled_filter_value" placeholder="默认 1；有些表用 bit(1) 则写 1"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="启用状态"><a-switch v-model="form.is_enabled" checked-children="开" un-checked-children="关"/></a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="排序号(sort)"><a-input-number v-model="form.sort" :min="0" :precision="0"/></a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import {
  mdRegisterList, mdRegisterCopyFromSystem, mdRegisterSave, mdRegisterDelete, mdRegisterRestorePreset
} from './api'

export default {
  name: 'MdRegisterList',
  data() {
    return {
      loading: false, saving: false, modal: false, scope: 'all',
      scopeOptions: [
        { value: 'all', label: '全部(系统+租户)' },
        { value: 'tenant', label: '仅租户自定义/副本' },
        { value: 'system', label: '仅系统预置(tenant_id=0)' }
      ],
      sourceTables: [
        { v: 'jsh_supplier', label: '客户/供应商（名称=supplier，编码可空）' },
        { v: 'jsh_organization', label: '部门（名称=org_abr，编码=org_no）' },
        { v: 'jsh_person', label: '职员（名称=name，编码可空）' },
        { v: 'jsh_material', label: '存货/商品（名称=name，编码=model）' },
        { v: 'jsh_depot', label: '仓库（名称=name，编码可空）' },
        { v: 'jsh_account', label: '资金账户（名称=name，编码可空）' },
        { v: 'jsh_project', label: '项目（自定义项目表）' }
      ],
      rows: [], form: {},
      cols: [
        { title: '操作', dataIndex: 'action', scopedSlots: { customRender: 'action' }, width: 170 },
        { title: '来源', dataIndex: '_source', scopedSlots: { customRender: 'src_slot' }, width: 110 },
        { title: '辅助核算类别', dataIndex: 'category_name', scopedSlots: { customRender: 'cat_slot' }, width: 140 },
        { title: '类型', dataIndex: 'category_type', width: 110 },
        { title: '主数据表', dataIndex: 'source_table', width: 160 },
        { title: '名称列', dataIndex: 'source_name_column', width: 140 },
        { title: '编码列', dataIndex: 'source_code_column', width: 130 },
        { title: '启用过滤值', dataIndex: 'enabled_filter_value', width: 110 },
        { title: '状态', dataIndex: 'is_enabled', scopedSlots: { customRender: 'en_slot' }, width: 140 },
        { title: 'sort', dataIndex: 'sort', width: 80 }
      ]
    }
  },
  created() { this.loadList() },
  methods: {
    loadList() {
      this.loading = true
      mdRegisterList({ scope: this.scope }).then(r => {
        this.loading = false
        if (r && r.success) {
          this.rows = (r.data || []).map((x, i) => ({
            ...x,
            _source: (x.tenant_id == null || Number(x.tenant_id) === 0) ? 'system' : 'tenant',
            _editable: !(x.tenant_id == null || Number(x.tenant_id) === 0)
          }))
        } else { this.$message.error((r && r.message) || '查询失败') }
      }).catch(() => { this.loading = false; this.$message.error('请求失败') })
    },
    copyFromSystem() {
      mdRegisterCopyFromSystem({}).then(r => {
        if (r && r.success) { this.$message.success('复制完成，共 ' + ((r.data && r.data.copied) || 0) + ' 条'); this.loadList() }
        else { this.$message.error((r && r.message) || '失败') }
      })
    },
    restorePreset() {
      this.$confirm({
        title: '确认恢复系统预置？',
        content: '会把已删除/修改的租户副本全部重置为系统预置，未修改的保持不变。',
        onOk: () => {
          mdRegisterRestorePreset({}).then(r => {
            if (r && r.success) { this.$message.success('恢复完成'); this.loadList() } else { this.$message.error((r && r.message) || '失败') }
          })
        }
      })
    },
    openEdit(r) {
      this.form = Object.assign({ category_type: 'system', is_enabled: true, sort: 10 }, r || {})
      this.modal = true
    },
    save() {
      if (!this.form.category_name) { this.$message.warning('请填写辅助核算类别'); return }
      this.saving = true
      mdRegisterSave(this.form).then(r => {
        this.saving = false
        if (r && r.success) { this.$message.success('保存成功'); this.modal = false; this.loadList() }
        else { this.$message.error((r && r.message) || '保存失败') }
      }).catch(() => { this.saving = false; this.$message.error('请求失败') })
    },
    del(r) {
      this.$confirm({
        title: '删除「租户副本」 ' + r.category_name + ' ？',
        content: '该删除为软删：等效于「禁用该系统预置项对此租户生效」。可点击「恢复系统预置」还原。',
        okType: 'danger',
        onOk: () => {
          mdRegisterDelete({ id: r.id }).then(res => {
            if (res && res.success) { this.$message.success('已删除（副本）'); this.loadList() } else { this.$message.error((res && res.message) || '失败') }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.muted{color:#999}.small{font-size:12px}.text-red{color:#f5222d;font-weight:600}
</style>
